'use client';
import { useEffect, useRef, useCallback } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const useCardsShowHook: any = (selector: string, parentSelector: string) => {
    const gspTlRef = useRef<ScrollTrigger[]>([]);

    const getElementsShowAnimal = () => {
        if (!selector) return;
        // if (gspTlRef.current.length) return; // 已经注册过
        const eles = document.querySelectorAll(selector);
        if (eles.length === 0) return;
        const tl = gsap.fromTo(
            eles,
            { opacity: 0, y: 20 },
            {
                opacity: 1,
                y: 0,
                duration: 1.4,
                ease: 'power3.out',
                stagger: 0.2,
                scrollTrigger: {
                    trigger: parentSelector,
                    start: 'top 100%',
                    toggleActions: 'play none none none',
                    once: true,
                    // markers: true, // 开发时打开看触发位置
                },
            },
        );
        // gspTlRef.current?.push(tl.scrollTrigger!);
    };

    // 防止重新
    const getElems = useCallback(getElementsShowAnimal, [selector, parentSelector]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getElems();
        }

        return () => {
            gspTlRef.current.forEach((st: any) => st.kill());
            gspTlRef.current = [];
        };
    }, [getElems]);
};

export default useCardsShowHook;
